var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile is-multiline"},[_c('div',{staticClass:"column is-full"},[_c('window',{attrs:{"title":"Create a new poll"}},[_c('poll-creator')],1)],1),_c('div',{staticClass:"column"},[_c('window',{attrs:{"title":"View poll"}},[_c('poll',{attrs:{"slug":"test"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }